import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchDataStockRep = createAsyncThunk(
    'StockReportData/fetchDataStockRep',
    async ({ cmpdetail, UserDetail }, { rejectWithValue }) => {

        try {
            // /stock/supplierwise/particuar/demo?supplier_name=TESTING%20SUPPLIER
            const result = await GET(`/stock/supplierwise/particuar/${cmpdetail?.key}?supplier_name=${encodeURIComponent(UserDetail?.result?.user?.company_name)}`);
            return result;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message)
        }
    }
);

const StockReportDataSlice = createSlice({
    name: 'StockReportData',
    initialState: {
        result: [],
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataStockRep.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDataStockRep.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.result = action.payload;
            })
            .addCase(fetchDataStockRep.rejected, (state, action) => {
                state.status = 'failed';
                state.result = [];
                state.error = action.payload;
            });
    },
});

export default StockReportDataSlice.reducer;